import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        lockSemesterList : [],
        userHasClassList : [],
    },
    getters: {
        getLockSemesterList: state => state.lockSemesterList,
        getUserHasClassList: state => state.userHasClassList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setLockSemesterList(state, { resp }){
            if (resp) {
                state.lockSemesterList = resp.data.data
            }else{
                state.lockSemesterList = [{}]
            }
        },
        setUserHasClassList(state, { resp }){
            if (resp) {
                state.userHasClassList = resp.data.data
            }else{
                state.userHasClassList = [{}]
            }
        },
    },
    actions: {
        getLockSemesterList({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/locksemester?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setLockSemesterList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getUserHasClassList({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/locksemester/get-user/'+param.lock_id+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setUserHasClassList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        updateLockSemester({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/locksemester/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
